/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enums_Leerjaarnumber_Zes3Inputs */

const nl_enums_leerjaarnumber_zes3 = /** @type {(inputs: Enums_Leerjaarnumber_Zes3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6`)
};

/**

* @param {Enums_Leerjaarnumber_Zes3Inputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const enums_leerjaarnumber_zes3 = /** @type {((inputs?: Enums_Leerjaarnumber_Zes3Inputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enums_Leerjaarnumber_Zes3Inputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_enums_leerjaarnumber_zes3(inputs)
});
export { enums_leerjaarnumber_zes3 as "enums.LeerjaarNumber.Zes" }